import { useCallback } from 'react';

import log from 'loglevel';

import { useUserCommunicationsStore } from '../../../store';
import { useOptimisticEmailRead } from '../shared/useOptimisticEmailRead';

export const useAutoMarkAsReadUserCommunication = () => {
  const getUserCommunicationByMessageId = useUserCommunicationsStore(
    (state) => state.getUserCommunicationByMessageId,
  );
  const { markRead } = useOptimisticEmailRead();

  const handleAutoMarkAsReadUserCommunication = useCallback(
    async (messageId: string) => {
      const userCommunication = getUserCommunicationByMessageId(messageId);

      if (!userCommunication) {
        log.debug(
          `UserCommunication with messageId ${messageId} not found for auto mark as read`,
        );
        return;
      }

      await markRead(userCommunication);
    },
    [getUserCommunicationByMessageId, markRead],
  );

  return {
    handleAutoMarkAsReadUserCommunication,
  };
};
